import {Button, Group, Input, type InputProps} from 'react-aria-components'

import EyeSvg from '@/assets/icons/eye.svg?react'
import EyeOffSvg from '@/assets/icons/eye-off.svg?react'

import style from './PasswordInput.module.scss'

interface Props extends InputProps {
  ref: RefCallback<HTMLInputElement>
  className?: string
  inputClassName?: string
  buttonClassName?: string
}

export default memo<Props>(function PasswordInput({
  ref,
  inputClassName,
  buttonClassName,
  className,
  ...rest
}) {
  const [isShowPassword, setIsShowPassword] = useState(false)

  return (
    <Group className={clsx(style.InputGroup, className)}>
      <Input
        ref={ref}
        type={isShowPassword ? 'text' : 'password'}
        className={clsx(style.Input, inputClassName)}
        {...rest}
      />
      <Button
        aria-label={isShowPassword ? 'Hide password' : 'Show password'}
        onPress={() => {
          setIsShowPassword(!isShowPassword)
        }}
        className={clsx(style.Button, buttonClassName)}
      >
        {isShowPassword ? <EyeOffSvg /> : <EyeSvg />}
      </Button>
    </Group>
  )
})
